import PrintRecipeModal from '@/app/medical-record/components/recipe/modals/PrintRecipe.vue';

let VueComponent;
let component;

function close() {
  if (!component) return;
  const current = component;
  component = null;
  current.show = false;
  current.$nextTick(() => current.$destroy());
}

function open(parent, props = {}, listeners = {}) {
  close();

  component = new VueComponent({
    parent,
    data: {
      props,
      listeners,
    },
  });

  component.$mount();
}

export default function install(Vue) {
  VueComponent = Vue.extend({
    data() {
      return {
        show: true,
        props: {},
        listeners: {},
      };
    },
    render(h) {
      return h(PrintRecipeModal, {
        props: { ...this.props, show: this.show },
        on: {
          ...this.listeners,
          close: () => {
            if (this.listeners.close) {
              this.listeners.close();
            }
            close();
          },
        },
      });
    },
  });

  Object.defineProperty(Vue.prototype, '$printRecipe', {
    get() {
      return { open, close };
    },
  });
}
